import React from "react";

export default function Contact() {
  return (
    <section id="contact" className="w-full max-w-5xl mx-auto my-6 px-2 sm:px-6 md:px-8">
      <h2 className="text-2xl font-extrabold text-[#213448] dark:text-slate-100">Contact</h2>
      <div className="mb-6 h-1 w-16 rounded bg-[#94B4C1] dark:bg-[#94B4C1]" />

      <div className="space-y-3">
        <div>
          <span className="font-bold text-gray-800 dark:text-slate-200">Email:</span>{" "}
          <a
            href="mailto:siddhantkumar052@gmail.com"
            className="break-all font-extrabold text-[#547792] transition hover:text-orange-500 dark:text-[#b8d5e6] dark:hover:text-[#F59E0B]"
          >
            siddhantkumar052@gmail.com
          </a>
        </div>
        <div>
          <span className="font-bold text-gray-800 dark:text-slate-200">LinkedIn:</span>{" "}
          <a
            href="https://www.linkedin.com/in/siddhantkumar052/"
            target="_blank"
            rel="noopener noreferrer"
            className="break-all font-extrabold text-[#547792] transition hover:text-orange-500 dark:text-[#b8d5e6] dark:hover:text-[#F59E0B]"
          >
            linkedin.com/in/siddhantkumar052
          </a>
        </div>
        <div>
          <span className="font-bold text-gray-800 dark:text-slate-200">GitHub:</span>{" "}
          <a
            href="https://github.com/siddhantkumar052"
            target="_blank"
            rel="noopener noreferrer"
            className="break-all font-extrabold text-[#547792] transition hover:text-orange-500 dark:text-[#b8d5e6] dark:hover:text-[#F59E0B]"
          >
            github.com/siddhantkumar052
          </a>
        </div>
      </div>
    </section>
  );
}
